<template>
    <div class="fileViewer">
        <div ref="fileViewer" :id="viewerId" style="height: 100%;"></div>

        <div class="fileViewer__controls svgControl">
            <div class="svgControl__zoomControl svgControl__zoomControl--zoomOut" @click.prevent="zoomOut">
                <i class="fas fa-minus"></i>
            </div>
            <div class="svgControl__label">
                {{ displayZoom }}
            </div>
            <div class="svgControl__zoomControl svgControl__zoomControl--zoomIn" @click.prevent="zoomIn">
                <i class="fas fa-plus"></i>
            </div>
        </div>

        <div class="svgControlReset" @click.prevent="resetViewer">
            {{ $t('Reset') }}
        </div>
    </div>
</template>

<script>
    import { parseString, toSVG } from 'dxf'
    import svgPanZoom from 'svg-pan-zoom'
    import svg from '../../../mixins/svg'
    import {CncSvgAnalyzer} from "../../../v2/utils/cncSvgAnalyzer";

    export default {
        mixins: [svg],
        props: {
            viewerId: {
                type: String,
                required: true
            },
            fileId: {
                type: String,
                default() {
                    return null
                }
            },
            value: {
                type: String,
                default() {
                    return null
                }
            }
        },
        data() {
            return {
                elementId: '',
                loaded: false,
                url: null,
                isInChannel: false,
                spz: null,
                currentZoom: 1,
            }
        },
        computed: {
            displayZoom: function () {
                return Math.round(this.currentZoom * 100) + '%'
            }
        },
        methods: {
            setDisplayZoom() {
                this.displayZoom = this.currentZoom;
            },
            resetViewer() {
                this.spz.reset()
                this.currentZoom = this.spz.getZoom()
            },
            zoomIn() {
                this.spz.zoomIn()
                this.currentZoom = this.spz.getZoom()
            },
            zoomOut() {
                this.spz.zoomOut()
                this.currentZoom = this.spz.getZoom()
            },
            onFileLoaded(response) {
                const analyzer = new CncSvgAnalyzer(toSVG(parseString(response.data)));
                analyzer.parseForPanZoom();

                this.$refs.fileViewer.innerHTML = analyzer._outSvg;

                this.spz = svgPanZoom(`#${this.viewerId} > svg`, {
                    zoomEnabled: true,
                    controlIconsEnabled: false,
                    fit: true,
                    center: true
                });
                this.spz.setZoomScaleSensitivity(0.4);
                this.spz.setOnZoom(function (zoom) {
                    self.currentZoom = zoom;
                });
                this.spz.resize();
                this.spz.fit();
                this.spz.center();

                this.loaded = true
                //this.setupSvgPanZoom()
            },
            /*setupSvgPanZoom() {
                // $('#svg-pan-zoom-reset-pan-zoom').on('click', function() {
                //     this.spz.zoomOut()
                // })
                $('#svg-pan-zoom-reset-pan-zoom').trigger('click')
            },*/
            destroySvgPanZoom() {
                if (this.spz) {
                    // $('#svg-pan-zoom-reset-pan-zoom').off('click', function() {
                    //     this.spz.zoomOut()
                    // })
                    this.spz.destroy()
                }
            },
            loadFile(){
                if (this.value) {
                    axios.get(this.value).then(this.onFileLoaded)
                } else {
                    this.$refs.fileViewer.innerHTML = '<img src="/images/large_loader.gif" style="position: absolute; width: 150px; left: 50%; top: 50%; margin-left: -75px; margin-top: -75px;" />'
                }
            }
        },
        watch: {
            value() {
                if (!this.loaded && this.$refs.fileViewer) {
                    //this.destroySvgPanZoom()
                    this.$refs.fileViewer.innerHTML = ''
                    this.loadFile()
                }
            }
        },
        mounted() {
            this.loadFile()
        },
        beforeDestroy() {
            this.destroySvgPanZoom()
        }
    }
</script>

<style>
    .svgControl__zoomControl--zoomOut {
        cursor: zoom-out;
    }
    .svgControl__zoomControl--zoomIn {
        cursor: zoom-in;
    }
    .svgControlReset {
        position: absolute;
        bottom: 1rem;
        right: 1rem;
        color: var(--primary);
        font-weight: bold;
        font-size: .9rem;
        cursor: pointer;
    }
    .svgControl__label {
        margin: 0 1rem;
        color: #666;
        width: 40px;
        text-align: center;
    }
    .svgControl__zoomControl {
        font-size: 1.1rem;
        color: var(--primary);
    }
    .fileViewer__controls {
        position: absolute;
        bottom: 40px;
        left: 50%;
        background: white;
        display: flex;
        align-items: center;
        padding: .35rem 1.2rem;
        border-radius: 1.2rem;
        border: 1px solid #ccc;
        box-shadow: 0 2px 6px -4px #666;
    }


</style>
